import { createAction, props } from '@ngrx/store'
import { EmployeeData, PaginatedAPI, employeeAPIModel } from 'src/app/models/api.model'

const actionPrefix = '[dashboard]'

export const load_employee_summary_action = createAction(
  `${actionPrefix} load_employee_action`,
  props<{
    queryParams: {
      key: string
      value: string
    }[]
    searchRequestBody: any
  }>()
)

export const load_employee_summary_success_action = createAction(
  `${actionPrefix} load_employee_success_action`,
  props<{ employee: PaginatedAPI<employeeAPIModel> }>()
)

export const fetch_employee_with_reference_details = createAction(
  `${actionPrefix} fetch_employee_with_reference_details`,
  props<{ employeeId: string }>()
)

export const fetch_employee_with_reference_details_success = createAction(
  `${actionPrefix} fetch_employee_with_reference_details_success`,
  props<EmployeeData>()
)
